import { useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

const Index: React.FC = () => {
  const { pathname } = useLocation();

  const canUrl = useMemo(() => {
    return `${window.location.origin}${pathname}`;
  }, [pathname]);

  return (
    <Helmet>
      <link rel="canonical" href={canUrl} />
    </Helmet>
  );
};

export default Index;
